import { render } from "./OpenTaskCard.vue?vue&type=template&id=70d4c27d&scoped=true"
import script from "./OpenTaskCard.vue?vue&type=script&lang=js"
export * from "./OpenTaskCard.vue?vue&type=script&lang=js"

import "./OpenTaskCard.vue?vue&type=style&index=0&id=70d4c27d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d4c27d"]])

export default __exports__